import {AppointmentType} from '../utility/appointment-type.enum';
import {Specialty} from '../utility/speciality.enum';
export class Appointment {
    id?: number;
    uniqId?:number;
    externalId: string;
    apptType: AppointmentType;
    doctorName: string;
    doctorSpecialty: Specialty;
    apptDate: Date;
    apptTime?: string;
    venue: string;
    description?: string;
    markedAsGoing?: boolean;
    notGoingReason?: string;
    patientId: number;
    checkInDate?: Date;
    patientFullName?:string;
    patientMobileNumber?:string;
    checkOutDate?: Date;
    absenceReason?: string;
    careTeamNote?: string;
    apptDateTimeString?: string;
    doctorUserId?:string;
    searchBy?: string;
    patientExternalId?: string;
  }
